import { FAQSchema } from 'seo/types'
import { CMSFaq } from 'types'
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'

export const faqSchema = (faqs: CMSFaq[]): FAQSchema => {
  const mainEntity = faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.title,
    acceptedAnswer: {
      '@type': 'Answer',
      text: documentToPlainTextString(faq.description.json),
    },
  }))

  const schema: FAQSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity,
  }

  return schema
}
